import { apiGeneric } from "src/core/helpers/api"

window["_apiGeneric"] = apiGeneric
export default apiGeneric
